import React from 'react';
import { motion } from 'framer-motion';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function ProblemSections() {
  return <div className="space-y-24 md:space-y-32 px-6 pb-20" data-id="element-127">
      {/* SECTION 1 */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeInUp} className="max-w-2xl mx-auto" data-id="element-128">
        <h2 className="font-serif text-3xl md:text-4xl text-[#E8E0D4] mb-8" data-id="element-129">
          Esto no es una "señal". <br data-id="element-130" />
          <span className="text-[#C4956A] italic" data-id="element-131">Es un patrón.</span>
        </h2>

        <p className="text-[#9B9285] text-lg mb-6" data-id="element-132">
          Si lo tuyo fuera una verdad clara, no te estaría pasando así:
        </p>

        <ul className="space-y-4 text-[#E8E0D4] text-lg mb-8" data-id="element-133">
          {['con urgencia', 'con culpa', 'con necesidad de certeza 100%', 'con noches rotas', 'con ganas de confesar o pedir confirmación solo para poder respirar'].map((item, i) => <li key={i} className="flex items-start" data-id="element-134">
              <span className="text-[#C4956A] mr-3 mt-1.5 h-1.5 w-1.5 rounded-full bg-[#C4956A] flex-shrink-0" data-id="element-135"></span>
              {item}
            </li>)}
        </ul>

        <p className="text-xl font-serif italic text-[#C4956A] border-l-2 border-[#C4956A]/30 pl-6 py-2" data-id="element-136">
          Eso no es claridad. Eso es alarma.
        </p>
      </motion.section>

      {/* SECTION 2 */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeInUp} className="max-w-2xl mx-auto" data-id="element-137">
        <h2 className="font-serif text-3xl md:text-4xl text-[#E8E0D4] mb-8" data-id="element-138">
          El loop que te está robando la paz
        </h2>

        <div className="bg-[#1A1815] p-6 rounded-lg border border-[#C4956A]/10 mb-8 text-center" data-id="element-139">
          <p className="text-[#E8E0D4] font-medium text-lg" data-id="element-140">
            Pensamiento <span className="text-[#C4956A]" data-id="element-141">→</span> ansiedad{' '}
            <span className="text-[#C4956A]" data-id="element-142">→</span> compulsión{' '}
            <span className="text-[#C4956A]" data-id="element-143">→</span> alivio breve{' '}
            <span className="text-[#C4956A]" data-id="element-144">→</span> regreso más fuerte.
          </p>
        </div>

        <p className="text-[#9B9285] text-lg mb-6" data-id="element-145">La compulsión puede ser:</p>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-146">
          {["preguntar '¿me amas?'", 'confesar cada duda', "googlear 'señales de que…'", "revisar recuerdos para 'probar' algo", 'compararte con otras parejas', 'testear a tu pareja'].map((item, i) => <li key={i} className="bg-[#1A1815]/50 px-4 py-3 rounded border border-[#9B9285]/10 text-[#E8E0D4]" data-id="element-147">
              {item}
            </li>)}
        </ul>

        <p className="text-[#E8E0D4] text-lg leading-relaxed" data-id="element-148">
          Y sí: calma por un rato.
          <br data-id="element-149" />
          Pero el cerebro aprende:{' '}
          <span className="italic text-[#9B9285]" data-id="element-150">
            "cuando aparezca el pensamiento, hacemos esto"
          </span>
          .<br data-id="element-151" />
          <span className="text-[#C4956A] font-medium" data-id="element-152">Por eso vuelve.</span>
        </p>
      </motion.section>

      {/* COST OF THE LOOP — psychological weight */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeInUp} className="max-w-2xl mx-auto" data-id="element-153">
        <div className="bg-gradient-to-b from-[#1A1815] to-[#0F0E0C] rounded-xl p-8 md:p-10 border border-[#C4956A]/15 relative overflow-hidden" data-id="element-154">
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C4956A]/40 to-transparent" data-id="element-155"></div>

          <h3 className="font-serif text-2xl md:text-3xl text-[#E8E0D4] mb-6 text-center" data-id="element-156">
            ¿Cuánto te está costando{' '}
            <span className="text-[#C4956A] italic" data-id="element-157">no</span> hacer nada?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-158">
            <div className="text-center p-4" data-id="element-159">
              <div className="text-3xl mb-2" data-id="element-160">🌙</div>
              <p className="text-[#E8E0D4] font-medium mb-1" data-id="element-161">Noches perdidas</p>
              <p className="text-[#9B9285] text-sm" data-id="element-162">
                Cada episodio te roba 2-4 horas de sueño. Multiplica eso por
                semanas.
              </p>
            </div>
            <div className="text-center p-4" data-id="element-163">
              <div className="text-3xl mb-2" data-id="element-164">💔</div>
              <p className="text-[#E8E0D4] font-medium mb-1" data-id="element-165">
                Tu relación se desgasta
              </p>
              <p className="text-[#9B9285] text-sm" data-id="element-166">
                Cada confesión, cada "¿me amas?", cada test… erosiona la
                confianza.
              </p>
            </div>
            <div className="text-center p-4" data-id="element-167">
              <div className="text-3xl mb-2" data-id="element-168">🧠</div>
              <p className="text-[#E8E0D4] font-medium mb-1" data-id="element-169">
                Tu mente se entrena peor
              </p>
              <p className="text-[#9B9285] text-sm" data-id="element-170">
                Cada compulsión refuerza el loop. Mañana será más fuerte que
                hoy.
              </p>
            </div>
          </div>

          <p className="text-center text-[#C4956A] font-serif italic text-lg" data-id="element-171">
            El loop no se pausa solo. Se alimenta o se interrumpe.
          </p>
        </div>
      </motion.section>

      {/* SECTION 3 */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeInUp} className="max-w-2xl mx-auto" data-id="element-172">
        <h2 className="font-serif text-3xl md:text-4xl text-[#E8E0D4] mb-8" data-id="element-173">
          Lo que te prometieron no sirve aquí
        </h2>

        <div className="grid grid-cols-2 gap-4 mb-8 font-serif italic text-[#9B9285] text-lg text-center" data-id="element-174">
          <div className="p-4 border border-[#9B9285]/20 rounded line-through decoration-[#C4956A]/40" data-id="element-175">
            "Respira."
          </div>
          <div className="p-4 border border-[#9B9285]/20 rounded line-through decoration-[#C4956A]/40" data-id="element-176">
            "Piensa positivo."
          </div>
          <div className="p-4 border border-[#9B9285]/20 rounded line-through decoration-[#C4956A]/40" data-id="element-177">
            "Habla y ya."
          </div>
          <div className="p-4 border border-[#9B9285]/20 rounded line-through decoration-[#C4956A]/40" data-id="element-178">
            "Haz una lista de pros y contras."
          </div>
        </div>

        <div className="space-y-6 text-[#E8E0D4] text-lg leading-relaxed" data-id="element-179">
          <p data-id="element-180">
            Todo eso falla por una razón: intenta ganarle a la mente con
            argumentos…
            <br data-id="element-181" />
            cuando el problema real es lo que haces{' '}
            <strong className="text-[#C4956A] font-normal" data-id="element-182">después</strong> del
            pensamiento.
          </p>
          <p data-id="element-183">
            Necesitas un sistema que funcione cuando estás activada.
            <br data-id="element-184" />
            No cuando estás tranquila leyendo consejos.
          </p>
        </div>
      </motion.section>
    </div>;
}